import { Header } from '../components'

export function HeaderContainer({ children }) {
  return (
    <Header>
      <Header.Frame>
        <Header.Name to="/home"><span>Aldo</span></Header.Name>
        <Header.Nav>
          <Header.NavLink to="/home">.home</Header.NavLink>
          <Header.NavLink to="/work">.projects</Header.NavLink>
          <Header.NavLink to="/contact">.contact</Header.NavLink>
        </Header.Nav>
      </Header.Frame>
      {children}
    </Header>
  )
}